import $ from "jquery";
import './style.css';

$(function() {
    $('#buttonLogin').on('click', null, function() {
        $('#loginForm').submit();
    });

    $('#email').keyup(function(e){
        if(e.keyCode == 13){
            $('#psswd').focus();
        }
    });

    $('#psswd').keyup(function(e){
        if(e.keyCode == 13){
            $('#loginForm').submit();
        }
    });

    $("#resetPsswd").on('click', function () {
        var email = $("#email").val();

        if(email==''){
            $(".errordiv").text("Insert the login or email.");
            $(".errordiv").show();
        }else{
            window.location.replace("https://www.gkiberia.com/loggers/resetPassword?email="+email);
        }
    });

    $("#buttonSignUp").on('click', function () {
        window.location.replace("signup");
    });

    $("#showPassword")
    .on('mousedown', function(){
        console.log("mousedown");
        $("#psswd").attr('type', 'text');
        $("#showPassword").removeClass('fa-eye-slash').addClass('fa-eye');
    })
    .on('mouseup', function(){
        console.log("mouseup");
        $("#psswd").attr('type', 'password');
        $("#showPassword").removeClass('fa-eye').addClass('fa-eye-slash');
    });

});
